import React from "react";
import './Error404.css'

function Error404() {
    return(
        <div className="error_404_page">
            <h1>404</h1>
            stop searching my site. it's still under construction lol
            <br></br>
            <a href="/">COME BACK HOME (by 2NE1)</a>
        </div>
    );
}

export default Error404;